import defaultSettings from '@/settings'

const title = defaultSettings.title || '汇服八方'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
